import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-page-ribbon',
  standalone: true,
  imports: [],
  templateUrl: './page-ribbon.component.html',
  styleUrl: './page-ribbon.component.scss',
})
export class PageRibbonComponent {
  /** Solo en producción no se muestra el ribbon */
  get showRibbon(): boolean {
    return !environment.production;
  }

  /** Texto: DEMO o DEV */
  get ribbonLabel(): string {
    if (environment.demo) return 'DEMO';
    if (environment.dev) return 'DEV';
    return '';
  }
}
